import _ from 'lodash';

export default {
  methods: {
    unique(key) {
      return _.uniq(_.flatten(_.map(this.analytics, key)));
    },
    uniqueCounts(key) {
      return _.countBy(this.unique(key));
    },
  },
};
